import { Stack } from '@healthinal/ui';
import { createFileRoute } from '@tanstack/react-router';
import { PatientHistory } from './components/PatientHistory.tsx';

export const Route = createFileRoute('/patients/$patientId/history')({
  component: PatientHistoryRoute,
  staticData: { title: 'Verlauf' },
});

function PatientHistoryRoute() {
  const { patientId } = Route.useParams();

  return (
    <Stack flex={1} gap={2}>
      <PatientHistory patientId={patientId} />
    </Stack>
  );
}
